import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteExamQuestionGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type DeleteExamQuestionGroupMutation = { __typename?: 'Mutation', deleteExamQuestionGroup?: { __typename?: 'DeleteExamQuestionGroupPayload', successful?: boolean | null, examQuestionGroup?: { __typename?: 'ExamQuestionGroup', id: number } | null } | null };

export const DeleteExamQuestionGroupDocument = gql`
    mutation DeleteExamQuestionGroup($id: Int!) {
  deleteExamQuestionGroup(id: $id) {
    successful
    examQuestionGroup {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteExamQuestionGroupGQL extends Apollo.Mutation<DeleteExamQuestionGroupMutation, DeleteExamQuestionGroupMutationVariables> {
    document = DeleteExamQuestionGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }